export const franchiseStats = [
  { value: '12+', label: '年行业积淀' },
  { value: '8+', label: '省份覆盖' },
  { value: '200+', label: '合作门店' },
  { value: '98%', label: '加盟商续签率' },
];

export const orgLevels = [
  {
    level: 1,
    title: '颜轻至总部',
    subtitle: '麦杰集团',
    desc: '品牌战略 · 产品研发 · 标准制定 · 培训赋能 · 数字化系统',
    icon: 'ri-building-2-line',
    color: 'bg-brand-deep',
  },
  {
    level: 2,
    title: '区域经理',
    subtitle: '省级区域负责人',
    desc: '区域市场拓展 · 加盟商招募 · 巡店督导 · 区域资源协调',
    icon: 'ri-map-pin-user-line',
    color: 'bg-brand-dark',
  },
  {
    level: 3,
    title: '城市经理',
    subtitle: '地市级运营负责人',
    desc: '城市运营管理 · 门店日常支持 · 营销活动策划 · 顾客资源对接',
    icon: 'ri-community-line',
    color: 'bg-brand-brown',
  },
  {
    level: 4,
    title: '门店店长',
    subtitle: '门店经营管理者',
    desc: '门店日常运营 · 顾客服务管理 · 团队建设 · 业绩目标达成',
    icon: 'ri-store-2-line',
    color: 'bg-brand-warm',
  },
  {
    level: 5,
    title: '瘦身顾问',
    subtitle: '一线服务人员',
    desc: '顾客接待咨询 · 方案定制跟进 · 服务执行落地 · 顾客关系维护',
    icon: 'ri-user-heart-line',
    color: 'bg-brand-gold',
  },
];

export const franchiseAdvantages = [
  {
    icon: 'ri-shield-check-line',
    title: '区域保护机制',
    desc: '签订区域保护协议，同城同品牌不重复授权，确保您的市场独占权益，无需担忧同品牌竞争。',
  },
  {
    icon: 'ri-graduation-cap-line',
    title: '系统培训赋能',
    desc: '入驻前全方位培训，涵盖产品知识、服务规范、门店管理、顾客沟通等核心技能，开业即上手。',
  },
  {
    icon: 'ri-megaphone-line',
    title: '营销策划支持',
    desc: '总部统一品牌推广物料，配合区域营销活动策划，线上私域流量运营指导，持续赋能客源增长。',
  },
  {
    icon: 'ri-computer-line',
    title: '数字化运营系统',
    desc: '统一的门店数字化管理系统，实时数据看板，顾客管理、服务记录、业绩追踪一体化处理。',
  },
  {
    icon: 'ri-customer-service-2-line',
    title: '全周期售后保障',
    desc: '城市经理定期驻店支持，区域经理季度巡检，总部专项问题响应，全生命周期陪伴式运营扶持。',
  },
  {
    icon: 'ri-leaf-line',
    title: '完整产品供应链',
    desc: '自主研发产品体系，稳定供应链保障，统一品质管控，无需加盟商自行采购，省心又省力。',
  },
];

export const targetGroups = [
  {
    icon: 'ri-scissors-line',
    title: '美容院经营者',
    desc: '已有门店资源与顾客基础，希望拓展健康管理赛道，实现业务升级转型。',
  },
  {
    icon: 'ri-heart-pulse-line',
    title: '健康管理创业者',
    desc: '对健康管理行业有热情，希望依托成熟品牌与标准化体系快速启动事业。',
  },
  {
    icon: 'ri-user-star-line',
    title: '区域代理商/合伙人',
    desc: '具备区域资源整合能力，希望以城市经理或区域经理身份参与品牌扩张。',
  },
  {
    icon: 'ri-group-line',
    title: '有私域资源的创业者',
    desc: '积累了一定女性用户群体或社群资源，希望将流量转化为稳定收益。',
  },
];

export const supportItems = [
  { icon: 'ri-box-3-line', title: '产品支持', desc: '自研健康产品 统一品质管控' },
  { icon: 'ri-palette-line', title: '品牌推广', desc: '统一视觉体系 全国品牌曝光' },
  { icon: 'ri-bar-chart-line', title: '营销策划', desc: '活动方案设计 私域运营指导' },
  { icon: 'ri-book-open-line', title: '培训赋能', desc: '系统课程体系 持续能力提升' },
  { icon: 'ri-tools-line', title: '售后服务', desc: '驻店支持服务 全程问题响应' },
  { icon: 'ri-dashboard-3-line', title: '数字化管理', desc: '门店管理系统 实时数据看板' },
  { icon: 'ri-layout-grid-line', title: '门店标准', desc: 'SI标准规范 装修选址指导' },
  { icon: 'ri-smartphone-line', title: '私域运营', desc: '社群运营方法 线上获客策略' },
];

export const applySteps = [
  {
    step: '01',
    title: '在线咨询',
    desc: '填写加盟申请表，品牌顾问将在24小时内与您联系，初步了解您的需求与背景。',
    icon: 'ri-questionnaire-line',
  },
  {
    step: '02',
    title: '资料审核',
    desc: '提交相关资料，招商团队评估区域市场情况，确认合作意向与基本条件。',
    icon: 'ri-file-list-3-line',
  },
  {
    step: '03',
    title: '实地考察',
    desc: '邀请您参观总部及样板门店，深入了解品牌文化、服务体系与运营模式。',
    icon: 'ri-map-2-line',
  },
  {
    step: '04',
    title: '签订协议',
    desc: '双方协商确认合作细节，签订品牌授权合作协议，明确区域保护范围。',
    icon: 'ri-contract-line',
  },
  {
    step: '05',
    title: '系统培训',
    desc: '参加总部系统培训，掌握产品知识、服务标准、门店管理等全方位技能。',
    icon: 'ri-award-line',
  },
  {
    step: '06',
    title: '开业支持',
    desc: '总部派驻开业督导团队，协助门店选址、装修、招募团队，保障顺利开业。',
    icon: 'ri-store-2-line',
  },
];